"use client";

import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import ColorPicker from "@/components/ui/color-picker";

export default function ColorSwatchField({
    value,
    onChange,
    onOpenChange,
    "aria-label": ariaLabel,
}: {
    value: string;
    onChange: (v: string) => void;
    onOpenChange?: (open: boolean) => void;
    "aria-label"?: string;
}) {
    return (
        <Popover onOpenChange={onOpenChange}>
            <PopoverTrigger asChild>
                <button
                    type="button"
                    aria-label={ariaLabel ?? value}
                    className="size-7 shrink-0 rounded border shadow-sm transition hover:opacity-90"
                    style={{ backgroundColor: value }}
                />
            </PopoverTrigger>
            <PopoverContent align="end" className="w-auto p-3">
                <ColorPicker initialColor={value} onColorChange={onChange} />
            </PopoverContent>
        </Popover>
    );
}
